import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility for merging Tailwind CSS classes with clsx and tailwind-merge.
 * This simplifies conditional class logic and ensures no Tailwind conflicts.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
